import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    months: {
        display: 'flex',
        minWidth: '140px'
    },
    createEventBtn: {
        width: '180px',
        marginRight: '12px',
        background: Colors.DARK_BLUE,
        color: 'white',
        '& :hover': {
            background: Colors.DARK_BLUE,
        }
    }
}))

export { useStyles }